/* MyNestUpgrade - scroll reveals for the brand sections.
   Elements are visible by default in CSS; this only adds the
   animation when JS is present, so nothing can hide content. */
(function () {
  function init() {
    var targets = document.querySelectorAll('.mnu-rise');
    if (!targets.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('mnu-on');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mnu-on');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
